import Vue from 'vue'

const formatCurrency = function (val, decLength = 2) {
    return Number(val).toFixed(decLength).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

const displayRupiah = function (val) {
    return "Rp. " + val
}

const displayWaktu = function (val, timezone = 'WIB') {
	const refHari = ['Senin','Selasa','Rabu','Kamis','Jumat','Sabtu','Minggu']
	const refBulan = ['Jan','Feb','Mar','Apr','Mei','Jun','Jul','Agu','Sep','Okt','Nop','Des']

	let hari = refHari[val.getUTCDay()-1]
	let tgl = val.getUTCDate() < 10 ? '0' + val.getUTCDate() : val.getUTCDate()
	let bulan = refBulan[val.getUTCMonth()]
	let tahun = val.getUTCFullYear()

	let jam = val.getUTCHours() < 10 ? '0' + val.getUTCHours() : val.getUTCHours()
	let menit = val.getUTCMinutes() < 10 ? '0' + val.getUTCMinutes() : val.getUTCMinutes()

	return `${hari}, ${tgl} ${bulan} ${tahun} ${jam}:${menit} ${timezone}`
}

// Use it globally
Vue.filter('formatCurrency', formatCurrency)
Vue.filter('displayRupiah', displayRupiah)
Vue.filter('displayWaktu', displayWaktu)



// WEBPACK FOOTER //
// ./src/filters.js